
























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import GlassOption, { getOptionRoute } from '@/data/glass-option'
import { mapGetters } from 'vuex'
import BaseModal from './ui/BaseModal.vue'
import DefaultButton from './ui/DefaultButton.vue'
import GlassOptionValue from '@/data/glass-option-value'
import InformationPopup from './InformationPopup.vue'
import InformationWebsite from '@/data/information-website'
import NavigationButtons from './ui/NavigationButtons.vue'
import ShoppingCart from '@/components/ShoppingCart.vue'
import { ICartItem } from '@/store/models/CartItem'
import { ModuleOption, BasketType } from '@/data/enums'
import '@/icons/cart'

@Component({
  computed: {
    ...mapGetters('cart', [
      'currentPrice'
    ])
  },
  components: {
    BaseModal,
    DefaultButton,
    InformationPopup,
    NavigationButtons,
    ShoppingCart
  }
})
export default class OptionModule extends Vue {
  @Prop({ default: true }) private canProceed?: boolean
  @Prop({ default: false }) private informationCode?: string | boolean
  @Prop({ default: false }) private info?: InformationWebsite | boolean
  @Prop({ default: (): ModuleOption[] => [] }) private optionIds!: ModuleOption[]
  @Prop() private optionId!: ModuleOption
  @Prop({ default: false }) private showMiniCart?: boolean
  @Prop() private prev?: string
  @Prop() private next?: string
  private showCart: boolean = false
  private showInfo: boolean = false

  private get displayMiniCart (): boolean {
    if (this.$store.state.data.optician.basketType === BasketType.None) {
      return false
    }
    return this.showMiniCart || false
  }

  private get displayTotal (): number {
    return this.$store.state.cart.items.length
  }

  private get showAmount (): boolean {
    return this.$store.state.data.optician.basketType === BasketType.Amount
  }

  private get showPrice (): boolean {
    if (!this.$store.state.data.optician.showPrices) {
      return false
    }
    return this.$store.state.data.optician.basketType === BasketType.Total ||
    this.$store.state.data.optician.basketType === BasketType.Current
  }

  private get currentItem (): ICartItem | undefined {
    return this.$store.state.cart.currentItem
  }

  private get currentOption (): GlassOption | undefined {
    if (this.currentItem && this.currentItem.type) {
      return this.currentItem.type.options
        .find((option: GlassOption) => option.optionId === this.optionId)
    }
  }

  private get moduleOptions (): GlassOption[] | undefined {
    if (this.currentItem && this.currentItem.type) {
      return this.currentItem.type.options.filter((option: GlassOption) =>
        this.optionIds.indexOf(option.optionId) !== -1)
    }
  }

  private mounted () {
    if (this.currentOption && this.currentOption.optionId !== ModuleOption.Suncolor) {
      const selectedValue = this.currentOption.values.find((optionValue: GlassOptionValue) => optionValue.selected)
      if (!selectedValue) {
        this.currentOption.values.forEach((optionValue: GlassOptionValue) => {
          // check if option has a selected value
          if (optionValue.isDefault && !optionValue.selected) {
            this.$store.dispatch('cart/toggleOptionValue', optionValue)
              .catch((err) => console.error(err))
          }
        })
      }
    }
  }

  private get previousRoute (): string {
    if (this.prev) {
      return this.prev
    } else {
      const currentRoute = getOptionRoute(this.optionId)
      const previousIndex = this.routes.indexOf(currentRoute) - 1
      return (previousIndex < 0)
        ? '/glasses/glass'
        : this.routes[previousIndex]
    }
  }

  private get nextRoute (): string {
    if (this.next) {
      return this.next
    } else {
      const currentRoute = getOptionRoute(this.optionId)
      const nextIndex = this.routes.indexOf(currentRoute) + 1
      return (nextIndex >= this.routes.length)
        ? `/cart`
        : this.routes[nextIndex]
    }
  }

  private get routes (): string[] {
    let routes: string[] = []
    if (this.currentItem && this.currentItem.type) {
      const options = this.currentItem.type.options
        .filter((option: GlassOption) => option.optionId !== 5 && option.fullscreen !== 1)
      const fullscreenOptions = this.currentItem.type.options
        .filter((option: GlassOption) => (option.optionId !== 5 && option.fullscreen === 1))
      if (fullscreenOptions.length) {
        routes = fullscreenOptions.map((fullscreenOption) => getOptionRoute(fullscreenOption.optionId))
      }
      if (options.length) {
        routes.push('/glasses/extra')
      }
    }
    return routes
  }
}
